window.googleMapsFormatter = function(value, row) {
    if (!row.google_maps.latitude || !row.google_maps.longitude) {
        return '';
    }

    const attributes = [
        { key: 'title', value: row.google_maps.title },
        { key: 'latitude', value: row.google_maps.latitude },
        { key: 'longitude', value: row.google_maps.longitude },
        { key: 'radius', value: row.google_maps.radius },
        { key: 'marker', value: row.google_maps.marker },
        { key: 'information', value: row.google_maps.information },
        { key: 'zoom', value: row.google_maps.zoom },
        { key: 'type', value: row.google_maps.type }
    ];

    const dataAttributes = attributes
        .filter(attr => typeof attr.value !== 'undefined')
        .map(attr => `data-${attr.key}="${attr.value}"`)
        .join(' ');

    return `<i class="google-maps-formattter fas fa-globe" ${dataAttributes} style="cursor: pointer"></i>`;
};
